<script lang="ts">
  let {
    survey, badge
  }: {
    survey: { title: string; slug: string };
    badge: string;
  } = $props();

  async function copyBadge() {
    await navigator.clipboard.writeText(badge);
    alert('응답 코드가 복사되었습니다');
  }
</script>

<svelte:head><title>응답 감사합니다</title></svelte:head>

<div class="shell">
  <main class="container">

    <div class="welcome-card">
      <div class="welcome-icon">🎉</div>
      <p class="welcome-slogan">We are so early</p>
      <h1 class="welcome-title">환영합니다!</h1>
      <p class="welcome-body">
        AX 문화를 함께 만들어가는<br/>
        커뮤니티의 시작에 오신 것을 환영합니다.
      </p>
    </div>

    <div class="notice-card">
      <div class="notice-label">📬 안내</div>
      <p class="notice-body">
        주신 설문 내용을 바탕으로<br/>
        <strong>이번 주 내 (늦어도 4월 중)</strong> 연락드리겠습니다.
      </p>
      <p class="notice-sub">
        입력하신 휴대폰 번호로 안내 메시지를 보내드립니다.
      </p>
    </div>

    <div class="badge-card">
      <div class="badge-label">🏷️ 응답 코드</div>
      <div class="badge-code">{badge}</div>
      <button onclick={copyBadge} class="copy-btn">복사</button>
      <p class="badge-hint">
        이 코드로 나중에 답변을 수정할 수 있어요.<br/>
        잃어버려도 새 코드로 응답하시면 됩니다.
      </p>
    </div>

    <a href={`/vibe_study/survey/${survey.slug}?badge=${badge}`} class="edit-link">
      답변 수정하기
    </a>

  </main>
</div>

<style>
  .shell {
    min-height: 100vh;
    background:
      radial-gradient(1200px 600px at 10% -10%, rgba(0, 122, 255, 0.12), transparent 60%),
      radial-gradient(900px 500px at 110% 20%, rgba(175, 82, 222, 0.10), transparent 60%),
      #f2f2f7;
    font-family: 'SUIT Variable', -apple-system, BlinkMacSystemFont, "SF Pro Text"
                 SUIT, system-ui, sans-serif;
    color: #000;
    letter-spacing: -0.01em;
  }

  @media (prefers-color-scheme: dark) {
    .shell { background: #000; color: #fff; }
  }

  .container {
    max-width: 480px;
    margin: 0 auto;
    padding: 48px 20px 80px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* ── Welcome ── */
  .welcome-card {
    text-align: center;
    padding: 40px 24px 32px;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    border-radius: 22px;
    border: 0.5px solid rgba(60, 60, 67, 0.14);
    background-image: linear-gradient(135deg,
      rgba(0, 122, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.72) 70%);
  }

  .welcome-icon { font-size: 52px; margin-bottom: 14px; }

  .welcome-slogan {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #007aff;
    margin-bottom: 8px;
  }

  .welcome-title {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -0.024em;
    margin-bottom: 12px;
  }

  .welcome-body {
    font-size: 16px;
    color: rgba(60, 60, 67, 0.7);
    line-height: 1.7;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  /* ── Notice ── */
  .notice-card {
    padding: 22px 20px;
    border-radius: 18px;
    background: rgba(0, 122, 255, 0.06);
    border: 1px solid rgba(0, 122, 255, 0.2);
  }

  .notice-label {
    font-size: 13px;
    font-weight: 600;
    color: #007aff;
    margin-bottom: 8px;
  }

  .notice-body {
    font-size: 15px;
    color: rgba(60, 60, 67, 0.9);
    line-height: 1.65;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  .notice-body strong { color: #007aff; font-weight: 700; }

  .notice-sub {
    margin-top: 10px;
    font-size: 13px;
    color: rgba(60, 60, 67, 0.55);
    line-height: 1.5;
    word-break: keep-all;
  }

  /* ── Badge ── */
  .badge-card {
    padding: 24px 20px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    border: 1.5px dashed rgba(60, 60, 67, 0.2);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .badge-label { font-size: 13px; color: rgba(60, 60, 67, 0.55); }

  .badge-code {
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #000;
  }

  .copy-btn {
    margin-top: 4px;
    padding: 10px 28px;
    background: #1c1c1e;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-family: inherit;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 120ms ease;
  }

  .copy-btn:active { opacity: 0.7; }

  .badge-hint {
    font-size: 12px;
    color: rgba(60, 60, 67, 0.5);
    line-height: 1.5;
    word-break: keep-all;
  }

  /* ── Edit link ── */
  .edit-link {
    text-align: center;
    font-size: 14px;
    color: #007aff;
    text-decoration: none;
  }

  .edit-link:hover { text-decoration: underline; }

  @media (prefers-color-scheme: dark) {
    .welcome-card, .badge-card {
      background: rgba(28, 28, 30, 0.72);
      border-color: rgba(84, 84, 88, 0.36);
    }
    .welcome-body { color: rgba(235, 235, 245, 0.6); }
    .notice-body { color: rgba(235, 235, 245, 0.8); }
    .notice-sub { color: rgba(235, 235, 245, 0.45); }
    .badge-label, .badge-hint { color: rgba(235, 235, 245, 0.45); }
    .badge-code { color: #fff; }
    .copy-btn { background: #f2f2f7; color: #000; }
  }
</style>
